import { render, staticRenderFns } from "./aAccessControlList.vue?vue&type=template&id=28501da9&scoped=true"
import script from "./aAccessControlList.vue?vue&type=script&lang=js"
export * from "./aAccessControlList.vue?vue&type=script&lang=js"
import style0 from "./aAccessControlList.vue?vue&type=style&index=0&id=28501da9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28501da9",
  null
  
)

export default component.exports